module.exports = __webpack_public_path__ + "img/item14.43ad9731.png";